import React, { useState } from 'react';
import MockTestModal from "../component/MockTestModal";
const MockTest = () => {
    const [showModal, setShowModal] = useState(false);

    return (
       <section className="service-details">
  <div
    className="shape"
    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/shape/shape-74.png)` }}
  ></div>
  <div className="auto-container">
    <div className="service-details-content">
      <div className="content-two">
        <div className="text">
          <h2>LLR Mock Test – Prepare Smarter with ASYSTA</h2>
          <p>Before you begin practicing on the road, the Central Motor Vehicle Rules require every new driver to hold a valid Learner's Licence. To obtain it, you must clear the Learner's Licence Registration (LLR) test — the first official step toward becoming a licensed driver in India.</p>
          <p>ASYSTA's LLR Mock Test helps you understand where you stand and how prepared you are for the real exam. Whether you're from a metro city or a small town, anyone across India can take this test and assess their knowledge instantly.</p>
          <p>Our mock test follows the guidelines of the Central Motor Vehicle Rules and includes 20 multiple‑choice questions covering essential topics such as road signs and symbols, hand signals, rules of the road, and basic traffic laws and CMVR‑based guidelines.</p>
          <p>To pass the mock test, you'll need to score at least 70%, just like the actual LLR exam.</p>
          <p>Getting started is simple. Enter your basic details, verify with an OTP, and you're ready to begin. This quick practice session helps you build confidence and understand what to expect on the real test day.</p>
        </div>
        
        <div className="text mt-5">
          <h2>We offer two levels of mock tests to suit every visitor:</h2>
        </div>
        
        <div className="row clearfix mt-4">
          <div className="col-lg-6 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Free Mock Test (Open for All)</h5>
              <p className="text-muted mt-2">Perfect for first‑time visitors who want a quick check of their driving‑theory knowledge. No login, no commitment — just a simple way to understand where you stand.</p>
            </div>
          </div>
          
          <div className="col-lg-6 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Advanced Mock Test (For Registered Users)</h5>
              <p className="text-muted mt-2">Create a free ASYSTA account to unlock deeper, more comprehensive tests with full‑length mock exams, scenario‑based questions, performance insights, and progress tracking.</p>
            </div>
          </div>
        </div>

        <div className="text mt-5">
          <h2>How It Works</h2>
        </div>
        
        <div className="row clearfix mt-4">
          <div className="col-lg-4 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Choose your test</h5>
              <p className="text-muted mt-2">Select between Free or Advanced mock test based on your needs.</p>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Answer questions</h5>
              <p className="text-muted mt-2">Answer all questions based on Indian road rules and RTO patterns.</p>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Get your results</h5>
              <p className="text-muted mt-2">Submit your test to view your score instantly with detailed insights.</p>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Review performance</h5>
              <p className="text-muted mt-2">Free users get basic score summary, registered users get detailed analysis.</p>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Practice anytime</h5>
              <p className="text-muted mt-2">Retake tests to strengthen your understanding and track progress.</p>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6 col-sm-12 single-column shadow-sm p-3 rounded">
            <div className="single-item">
              <div className="icon-box"><i className="flaticon-checkbox-mark"></i></div>
              <h5 className="ct">Guidelines for Best Results</h5>
              <p className="text-muted mt-2">Read questions carefully, stable internet connection, track progress for registered users.</p>
            </div>
          </div>
        </div>

        <div className="inner-box mt-5">
          <div className="download-option">
            <div className="icon-box">
              <img src={`${process.env.PUBLIC_URL}/assets/images/icons/icon-52.png`} alt="Test Icon" />
            </div>
            <h4>Ready to test your knowledge?</h4>
            <span>These tests help you prepare for the Learner's License exam and improve real‑world driving awareness.</span>
          </div>
          <div className="btn-box mt-4">
            <button 
              className="theme-btn btn-four mr-3"
              onClick={() => setShowModal(true)}
            >
              FREE MOCK TEST
            </button>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <MockTestModal show={showModal} onClose={() => setShowModal(false)} />
</section>
    );
};

export default MockTest;